import { render, staticRenderFns } from "./NewsReleaseDetails.vue?vue&type=template&id=64aad200&"
import script from "./NewsReleaseDetails.vue?vue&type=script&lang=ts&"
export * from "./NewsReleaseDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports